import { openMitigationStatuses, RiskMitigationPlanStatus } from "./RiskMitigationOverview.types";

// Mirrors RiskMitigationPlan.ShownTreatmentStatuses (Backend/Core/DomainModels/Risk/RiskMitigationPlan.cs): the open
// states plus Completed, i.e. everything except the terminals. Proposing a treatment supersedes whatever stood
// before it, so a risk has at most one plan in this set, which makes it the set that isolates a risk's current
// treatment from its superseded history.
export const shownTreatmentStatuses: Array<RiskMitigationPlanStatus> = [...openMitigationStatuses, RiskMitigationPlanStatus.Completed];

export function isPlanOverdue(deadline: string | null, status: RiskMitigationPlanStatus): boolean {
    if (!deadline || !openMitigationStatuses.includes(status)) return false;

    const startOfToday = new Date();
    startOfToday.setHours(0, 0, 0, 0);
    return new Date(deadline) < startOfToday;
}
